'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { Icon } from '@/components/Logo';
import classNames from '@/utils/classNames';
import isOAuthCallback from '@/utils/isOAuthCallback';
import usePixelWipe from './usePixelWipe';
import { markBootSplashComplete } from './bootSplash';
import styles from './PixelWipeLoader.module.css';

// Boot splash: a dark cover with the Nominal mark that erases itself with a pixelated clip-path wipe
// on mount, then unmounts. Lives in the persistent root tree, so it runs once per full page load
// (not on client navigations). Signals `markBootSplashComplete` so pattern reveals sequence after it.
export default function PixelWipeLoader() {
  const $ = _c(3);
  const overlayRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = typeof window !== "undefined" && isOAuthCallback(window.location.search);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const skip = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "hide",
      skip,
      onComplete: markBootSplashComplete
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const done = usePixelWipe(overlayRef, t1);
  if (done) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div ref={overlayRef} aria-hidden={true} className={classNames(styles.overlay, "pointer-events-none fixed inset-0 z-200 flex items-center justify-center bg-greyscale-950")}><div style={{
        width: "clamp(4rem, 6.00939vw + 2.59155rem, 8rem)"
      }}><Icon className="h-auto w-full text-stone-50" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}